<template :key="$route.params.leagueId">
  <div :key="$route.params.leagueId">
    <div class="navDiv MobileHide" id="topheader">
      <div
        style="
          height: 45px;
          background: #2c2d31;
          line-height: 45px;
          color: #e6e6e6;
          font-size: 12px;
        "
      >
        <span style="margin-left: 10px">{{
          $t("LanguageEn.TournamentInfo")
        }}</span>
      </div>
      <div
        style="
          height: 140px;
          background: #212225;
          line-height: 140px;
          color: white;
        "
        :key="$route.params.leagueId"
      >
        <img
          :key="$route.params.leagueId"
          :src="tournamentLogo + id"
          style="
            width: 67px;
            margin-left: 20px;
            margin-right: 20px;
            background: lightgrey;
            border-radius: 8px;
          "
        />
        {{ leagueTable | transliterate(cookiesObject.lang) }}
        <b-btn
          v-if="favsT.some((fav) => fav.id == id)"
          v-on:click="removeFavorite({ value: id, type: tournament })"
          style="
            background: none;
            width: 5px;
            height: 5px;
            border: none;
            margin-left: 10px;
          "
        >
          <img
            src="@/assets/orStar.png"
            style="width: 15px; margin-top: -32px; margin-left: -10px"
            alt=""
          />
        </b-btn>
        <b-btn
          v-else
          v-on:click="addToFavorites({ value: id, type: tournament })"
          style="
            background: none;
            width: 5px;
            height: 5px;
            margin-left: 10px;
            border: none;
          "
        >
          <img
            src="@/assets/favorite.svg"
            style="width: 15px; margin-top: -32px; margin-left: -10px"
            alt=""
          />
        </b-btn>
      </div>
      <nav
        class="navbar navbar-expand-sm navbar-light"
        style="background: #2c2d31; height: 45px"
      >
        <div class="collapse navbar-collapse" id="navbarNav">
          <ul class="navbar-nav pl-0 pr-0">
            <li class="nav-item">
              <router-link
                id="routerLink"
                style="font-weight: 550; color: lightgrey"
                :to="{ name: 'LeaguePageGames', params: { id: id } }"
              >
                {{ $t("LanguageEn.txtResults") }}</router-link
              >
              <!-- <img style="height: 22px; margin-right: 5px;" src="@/assets/results.png"> -->
            </li>
            <li class="nav-item">
              <router-link
                id="routerLink"
                style="font-weight: 550; color: lightgrey"
                :to="{ name: 'LeaguePage', params: { id: id } }"
              >
                {{ $t("LanguageEn.txtTable") }}
              </router-link>
              <!-- <img style="height: 22px; margin-right: 5px;" src="@/assets/leagueTable.png"> -->
            </li>
            <li class="nav-item">
              <router-link
                id="routerLink"
                style="font-weight: 550; color: lightgrey"
                :to="{ name: 'Archive', params: { id: id } }"
              >
                {{ $t("LanguageEn.archive") }}
              </router-link>
              <!-- <img style="height: 22px; margin-right: 5px;" src="@/assets/leagueTable.png"> -->
            </li>
          </ul>
        </div>
      </nav>
      <div style="color: black">
        <router-view :key="$route.path" />
      </div>
    </div>
    <div class="MobileShow">
      <div
        style="
          height: 45px;
          background: #2c2d31;
          line-height: 45px;
          color: #e6e6e6;
          font-size: 12px;
        "
      >
        <span style="margin-left: 10px">{{
          $t("LanguageEn.TournamentInfo")
        }}</span>
      </div>
      <div
        style="
          height: 140px;
          background: #212225;
          line-height: 140px;
          color: #e6e6e6;
          font-size: 14px;
        "
        :key="$route.params.leagueId"
      >
        <img
          :key="$route.params.leagueId"
          :src="tournamentLogo + id"
          style="
            width: 67px;
            margin-left: 20px;
            margin-right: 20px;
            background: lightgrey;
            border-radius: 8px;
          "
        />
        {{ leagueTable | transliterate(cookiesObject.lang) }}
        <b-btn
          v-if="favsT.some((fav) => fav.id == id)"
          v-on:click="removeFavorite({ value: id, type: tournament })"
          style="background: none; width: 5px; height: 5px; border: none"
        >
          <img
            src="@/assets/orStar.png"
            style="width: 15px; margin-top: -32px; margin-left: -10px"
            alt=""
          />
        </b-btn>
        <b-btn
          v-else
          v-on:click="addToFavorites({ value: id, type: tournament })"
          style="background: none; width: 5px; height: 5px; border: none"
        >
          <img
            src="@/assets/favorite.svg"
            style="width: 15px; margin-top: -32px; margin-left: -10px"
            alt=""
          />
        </b-btn>
      </div>
    </div>
    <nav
      class="nav MobileShow container-fluid"
      style="background: #141416; margin-bottom: 5px"
    >
      <div class="row" style="height: 4 0px">
        <div class="col">
          <router-link
            style="font-size: 13px"
            id="routerLink"
            :to="{ name: 'LeaguePageGames', params: { id: id } }"
            >{{ $t("LanguageEn.txtResults") }}</router-link
          >
        </div>
        <div class="col">
          <router-link
            style="font-size: 13px"
            id="routerLink"
            :to="{ name: 'LeaguePage', params: { id: id } }"
            >{{ $t("LanguageEn.txtTable") }}</router-link
          >
        </div>
        <div class="col">
          <router-link
            style="font-size: 13px"
            id="routerLink"
            :to="{ name: 'Archive', params: { id: id } }"
          >
            {{ $t("LanguageEn.archive") }}</router-link
          >
        </div>
      </div>
    </nav>
    <router-view class="MobileShow" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "LeaguePageNav",
  data() {
    return {
      id: "",
      tournamentLogo: "https://sportapi.zuniac.com/tournament/logo/",
      leagueTable: "",
      cookiesObject: "",
      tournament: "tournament",
    };
  },
  async mounted() {
    this.id = this.$route.params.leagueId;

    var cookiesObject = document.cookie
      .split(";")
      .map((cookie) => cookie.split("="))
      .reduce(
        (accumulator, [key, value]) => ({
          ...accumulator,
          [key.trim()]: decodeURIComponent(value),
        }),
        {}
      );
    this.cookiesObject = cookiesObject;
    const res = await fetch(
      "https://sportapi.zuniac.com/standings?portalId=" +
        (cookiesObject.portalId ? cookiesObject.portalId : 0) +
        "&token=" +
        cookiesObject.token +
        "&tournamentId=" +
        this.id
    );
    const data = await res.json();
    const leagueTable = data;
    this.leagueTable = leagueTable.standings[0].tournament.name;
  },
  methods: {
    ...mapActions(["removeFavorite", "addToFavorites"]),
  },
  computed: {
    ...mapGetters(["favsT", "httpReq"]),
  },
};
</script>

<style scoped>
.navDiv {
  width: auto;
  height: auto;
  color: black;
  background: #f9f9f9;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}

.nav-item {
  font-size: small;
}
.nav-link {
  height: 40px;
  color: green !important;
  text-align: center;
}

#routerLink {
  padding-top: 10%;
  display: inline-block;
  text-decoration: none;
  width: 90px !important;
  height: 43px !important;
  color: white;
  text-align: center !important;
}
#routerLink .navbar-nav li > a {
  text-transform: capitalize;
  transition: background-color 0.2s, color 0.2s;
}

#routerLink .navbar-nav li > a:focus {
  color: #f0af46;
}

.router-link-active {
  color: white !important;
  border-bottom: solid 3px #1c5e20;
}
/* Navbar link underline */

#topheader .navbar-nav li > a {
  text-transform: capitalize;
  transition: background-color 0.2s, color 0.2s;
}

#topheader .navbar-nav li > a:focus {
  color: #fff !important;
}

#topheader .navbar-nav li.active > a {
  background-color: #333;
  color: #fff;
}
@media only screen and (max-width: 770px) {
  body {
    background: #212529;
  }
  .navDiv2 {
    width: 100%;
    height: 60px;
    color: white;
    background: #1b1d20;
  }
  .MobileHide {
    display: none;
  }
  #routerLink {
    padding-top: 8px;
    display: inline-block;
    text-decoration: none;
    height: 40px;
    color: lightgray;
    font-weight: 500;
    text-align: center;
  }
}

@media only screen and (min-width: 770px) {
  .MobileShow {
    display: none;
  }
}
</style>
